import cn from '@/lib/cs';
import React from 'react';

const ArrowRightIcon = ({
	className,
	...props
}: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M19.8358 9.93868C19.3111 9.50938 18.7863 9.07665 18.2616 8.64053C17.3082 7.85007 16.3696 7.05963 15.4421 6.26917C13.6166 5.27428 11.7948 4.2828 9.96933 3.28791C8.77944 2.37139 7.59326 1.45488 6.40337 0.534946C5.68648 0.357774 4.96589 0.177172 4.249 0C3.90534 0.320272 3.56168 0.640568 3.21802 0.96084C3.25867 1.40377 3.29561 1.85008 3.33626 2.29301C5.0398 3.67631 6.48836 4.84155 7.64868 5.65586C9.50003 6.95399 11.3514 8.25554 13.2027 9.55367C14.3076 10.1908 15.4125 10.8279 16.5174 11.4651C14.3889 12.8416 12.2604 14.2181 10.1319 15.5945C9.24875 16.3577 8.36188 17.1243 7.4787 17.8875C6.73225 18.3203 5.9858 18.753 5.23935 19.1857C4.4929 19.9489 3.74645 20.7155 3 21.4787C3.24759 22.3203 3.49886 23.1618 3.74645 24C4.79591 23.8467 5.84538 23.6933 6.89854 23.54C8.99747 21.8058 11.1001 20.075 13.199 18.3407C15.1058 17.0426 17.0126 15.741 18.9194 14.4429C19.6917 13.5502 20.4677 12.6576 21.24 11.7683C20.7781 11.1618 20.3088 10.5486 19.8358 9.93868Z"
		/>
	</svg>
);
export default ArrowRightIcon;
